module.exports = __webpack_public_path__ + "static/media/logoHorizontal.6213820e.svg";